export default __webpack_public_path__ + "static/media/icon_atp.4b76af0b.svg";